export const EmptyColumn = {
    key: '-empty-',
    name: '',
    fieldName: '',
    minWidth: 20,
    maxWidth: 20,
    isResizable: false
};
export const EmptyStandarDataTableColumn = function () {
    return {
        name: '',
        minWidth: 20,
        maxWidth: 20,
        isResizable: false,
        onRender: () => ''
    };
};
export const NameStandarDataTableColumn = function (lang) {
    return {
        name: lang.name,
        minWidth: 200,
        maxWidth: 350,
        isResizable: true,
        onRender: ({ name }) => name
    };
};
export const CodeStandarDataTableColumn = function (lang) {
    return {
        name: lang.code,
        minWidth: 100,
        maxWidth: 250,
        isResizable: true,
        onRender: ({ code }) => code
    };
};
export const DescriptionStandarDataTableColumn = function (lang) {
    return {
        name: lang.description,
        minWidth: 200,
        maxWidth: 350,
        isResizable: true,
        onRender: ({ description }) => description
    };
};
export const OrderStandarDataTableColumn = function (lang) {
    return {
        name: lang.order,
        minWidth: 40,
        maxWidth: 50,
        isResizable: true,
        onRender: ({ order }) => order
    };
};
export const EnabledStandarDataTableColumn = function (lang) {
    return {
        name: lang.active_Male,
        minWidth: 50,
        maxWidth: 60,
        isResizable: true,
        onRender: ({ enabled }) => enabled ? 'Sí' : 'No'
    };
};
export const CreatedByStandarDataTableColumn = function (lang) {
    return {
        name: lang.createdBy,
        minWidth: 150,
        maxWidth: 250,
        isResizable: true,
        onRender: ({ createdBy }) => createdBy
    };
};
export const CreationDateStandarDataTableColumn = function (lang) {
    return {
        name: lang.creationDate,
        minWidth: 150,
        maxWidth: 250,
        isResizable: true,
        onRender: ({ creationDate }) => creationDate
    };
};
export const UpdatedByStandarDataTableColumn = function (lang) {
    return {
        name: lang.modifiedBy,
        minWidth: 150,
        maxWidth: 250,
        isResizable: true,
        onRender: ({ modifiedBy }) => modifiedBy
    };
};
export const UpdatedDateStandarDataTableColumn = function (lang) {
    return {
        name: lang.modificationDate,
        minWidth: 150,
        maxWidth: 250,
        isResizable: true,
        onRender: ({ modificationDate }) => modificationDate
    };
};
